module.exports = __webpack_public_path__ + "static/media/shalom.55e9f8ea.svg";